<ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<!-- Modal content-->
<div class="btn-black">
    <div class="row">
        <div class="col-9">
            <h4 class="modal-title pt-2 pl-3 pb-2 pr-0">{{'alert.reassign_alert' | translate}} #{{alertId}}</h4>
        </div>
        <div class="col-3">
            <button type="button" class="close pt-2 pl-0 pb-2 pr-2" (click)="activeModal.close()">&times;</button>
        </div>
    </div>
</div>
<div class="modal-body modal-body-gray">
    <div class="row">
        <div class="col-12">
            <strong>{{'alert.currently_attended' | translate}}</strong> {{attendedByName?(attendedByName):""}}
            <br>
            <div id="dropdown"><ngx-select-dropdown (change)="changeValue($event)" tabindex="0" [multiple]="false" [config]="config" [options]="options"></ngx-select-dropdown></div>
            <div id="err" class="error"></div><br>
        </div>
    </div>
</div>
<div class="modal-footer modal-body-gray text-right">
    <button type="button" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close()">
        {{'general.cancel' | translate}}
    </button>
    <button type="button" class="btn btn-green btn-h-green" (click)="reassignAlert()">
        {{'alert.reassign' | translate}}
    </button>
</div>

